import { render, staticRenderFns } from "./LocationSelector.vue?vue&type=template&id=8d60fed0&"
import script from "./LocationSelector.vue?vue&type=script&lang=js&"
export * from "./LocationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\Jatin\\Documents\\Source\\wiom-dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d60fed0')) {
      api.createRecord('8d60fed0', component.options)
    } else {
      api.reload('8d60fed0', component.options)
    }
    module.hot.accept("./LocationSelector.vue?vue&type=template&id=8d60fed0&", function () {
      api.rerender('8d60fed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LocationSelector.vue"
export default component.exports